import { FC } from 'react';

import { cn } from 'support/helpers/cn/cn';

type CountBadgeProps = {
  count: number;
  className?: string;
};

export const CountBadge: FC<CountBadgeProps> = ({ count, className }) => (
  <span
    className={cn(
      'flex items-center justify-center rounded-full bg-gray-900 text-xs font-medium text-white',
      className,
    )}
  >
    {count}
  </span>
);
